<template>
  <div :class="shown ? 'trash-item trash-1 show' : 'trash-item trash-1'">
    <div class="img-ct">
      <img :src="depositTypeImage('battery')" alt="">
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ["shown"],
  computed: {
    ...mapGetters('DepositTypes', ['depositTypeImage']),
  },
}
</script>